export enum EntrypointId {
  ExistingCustomerChangeStrategy = 'EXISTING_CUSTOMER__CHANGE_STRATEGY',
  ExistingCustomerNewBpCashInvest = 'EXISTING_CUSTOMER__NEW_BP__CASH_INVEST', // new bp with cash invest option
  ExistingCustomerNewBpInterest = 'EXISTING_CUSTOMER__NEW_BP__INTEREST', // new bp with interest product (Zinsprodukt)
  ExistingCustomerNewBpTopics = 'EXISTING_CUSTOMER__NEW_BP__TOPICS', // new bp with topics option
  ExistingCustomerNewBpVV = 'EXISTING_CUSTOMER__NEW_BP__VV', // new bp with globales portfolio
  ExistingCustomerNewIpsCashInvest = 'EXISTING_CUSTOMER__NEW_IPS__CASH_INVEST', // new ips cash invest
  ExistingCustomerNewIpsTopics = 'EXISTING_CUSTOMER__NEW_IPS__TOPICS', // new ips seletive anlage
  ExistingCustomerNewIpsVV = 'EXISTING_CUSTOMER__NEW_IPS__VV', // new ips globales?
  ExistingCustomerUpdateBp = 'EXISTING_CUSTOMER__UPDATE_BP',
  NewCustomerNewBpCashInvest = 'NEW_CUSTOMER__NEW_BP__CASH_INVEST',
  NewCustomerNewBpChild = 'NEW_CUSTOMER__NEW_BP__CHILD', // globales portfolio
  NewCustomerNewBpRetirement = 'NEW_CUSTOMER__NEW_BP__RETIREMENT',
  NewCustomerNewBpSimpleProposal = 'NEW_CUSTOMER__NEW_BP__SIMPLE_PROPOSAL',
  NewCustomerNewBpTangibleAssets = 'NEW_CUSTOMER__NEW_BP__TANGIBLE_ASSETS', // bloxxter
  NewCustomerNewBpTopics = 'NEW_CUSTOMER__NEW_BP__TOPICS', // selective anlage
  NewCustomerNewBpVV = 'NEW_CUSTOMER__NEW_BP__VV', // globales portfolio
}
